import React from 'react'
import styled from 'styled-components'
// import Lottie from 'react-lottie'

import Lottie from '../../Lottie'
import Button from 'components/Button'
import SectionComponent from './Section'
import Heading1Component from './Heading1'
import Paragraph from './Paragraph'
import * as blob1 from './Blobs/Blob_1.json'
import * as blob2 from './Blobs/Blob_2.json'
import * as blob3 from './Blobs/Blob_3.json'
import * as blob4 from './Blobs/Blob_4.json'

const Section = styled(SectionComponent)`
  background-color: #523c6c;
`

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`

const Heading1 = styled(Heading1Component)`
  margin-top: 0;
`

const Left = styled.div`
  max-width: 540px;

  @media (min-width: 768px) {
    margin-right: 20px;
  }
`

const MovingLogo = styled.div`
  padding: 18px;
  width: 100%;
  max-width: 340px;
  position: relative;
  height: 250px;
  @media (max-width: 767px) {
    order: -1;
  }

  & div {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`

const lottieOptions = [blob1, blob2, blob3, blob4].map(animationData => ({
  // Get a number between 0.7 and 1.0
  // speed: Math.random() / 3 + 0.7,
  speed: 1.0,
  options: {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }
}));

const Hero = () => (
  <Section>
    <Content>
      <Left>
        <Heading1>Helt sjef</Heading1>
        <Paragraph>
          På Spir får du som ungdom valgfrihet og kontroll for å jobbe med det som 
          interesserer deg ved siden av skolen.
        </Paragraph>
        <Button size="large" to="/register">
          Registrer deg
        </Button>
      </Left>
      <MovingLogo>
        {lottieOptions.map(({speed, options}) => <Lottie options={options} height={250} width={250} speed={speed} />)}
      </MovingLogo>
    </Content>
  </Section>
)

export default Hero



// WEBPACK FOOTER //
// ./src/pages/Landing/Hero.js